// extracted by mini-css-extract-plugin
module.exports = {"spinner":"DashboardsView_spinner__3OYDA"};